import React from "react";
import ReactHtmlParser from "react-html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import { Box, Link, Typography } from "@mui/material";
import type Correspondence from "@/src/_types/Authors/correspondence";
import NextLink from "next/link";

const AuthorCorrespondence = (
    {
        correspondences,
        hasEqualContributer,
        isDeceased,
        authorNoteFnEqual
    }: {
        correspondences: Correspondence[],
        hasEqualContributer: boolean,
        isDeceased: boolean,
        authorNoteFnEqual: string
    }
) => {
    return (
        <Box color="text.primary">
            {
                correspondences.length === 1 ? (
                    correspondences.map((correspondence: Correspondence, index: number) => (
                        <Box
                            key={`${correspondence.id || `correspondence-${index}`}`}
                            id={`${correspondence.id || `correspondence-${index}`}`}
                            component="aside"
                        >
                            <SpanTypography>
                                {
                                    correspondence.label
                                }
                            </SpanTypography>
                            <SpanTypography fontSize={'.875rem'}>
                                {
                                    ReactHtmlParser(correspondence.content)
                                }
                            </SpanTypography>
                            {
                                (correspondence.email && correspondence.email !== '') &&
                                correspondence.email.split(";").map((mail: string, index: number) => (
                                    <React.Fragment key={mail}>
                                        <Link
                                            component={NextLink}
                                            href={`mailto:${mail}`}>
                                            {mail}
                                        </Link>
                                        {index < correspondence.email.split(";").length - 1 && '; '}
                                    </React.Fragment>
                                ))
                            }
                        </Box>
                    ))
                ) : correspondences.length === 0 ? (
                    <Typography>
                        Warning: No corresponding author defined!
                    </Typography>
                ) : (
                    <>
                        <Typography component="b" fontSize={'.8rem'} fontWeight={700}>
                            Corresponding Authors:
                        </Typography>
                        {
                            correspondences.map((correspondence: Correspondence, index: number) => (
                                <Box
                                    key={`${correspondence.id || `correspondence-${index}`}`}
                                    id={`${correspondence.id || `correspondence-${index}`}`}
                                    component="aside"
                                >
                                    <SpanTypography>
                                        {
                                            correspondence.label
                                        }
                                    </SpanTypography>
                                    <SpanTypography fontSize={'.8rem'}>
                                        {
                                            ReactHtmlParser(
                                                correspondence.content.startsWith('Corresponding author:')
                                                    ? correspondence.content.slice('Corresponding author:'.length)
                                                    : correspondence.content
                                            )
                                        }
                                    </SpanTypography>
                                    {
                                        (correspondence.email && correspondence.email !== '') &&
                                        <Link
                                            component={NextLink}
                                            href={`mailto:${correspondence.email}`}>
                                            <SpanTypography fontSize={'.8rem'}>
                                                {
                                                    correspondence.email
                                                }
                                            </SpanTypography>
                                        </Link>
                                    }

                                </Box>
                            ))
                        }
                    </>
                )
            }
            {
                (hasEqualContributer || isDeceased) && (
                    <Typography>
                        {
                            authorNoteFnEqual
                                ? authorNoteFnEqual
                                : (!authorNoteFnEqual && !isDeceased)
                                && "# These authors have contributed equally."
                        }
                    </Typography>
                )
            }
        </Box>
    )
}

export default AuthorCorrespondence;
